module.exports = __webpack_public_path__ + "static/media/Florida School Boards Association Logo.d170cb0b.png";